module.exports = __webpack_public_path__ + "img/bytedance.dc5c0c88.png";